export default "__VITE_ASSET__G13g16Jh__"